<template>
    <div>
        <div onclick="window.open('https://angular.io/', '_blank')" class="pointer-hand">
            <article class="message" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
                <div class="message-body message-border-color-3">
                    <figure class="image is-1by1">
                        <img src="/img/technologie-angular.png" alt="Angular">
                    </figure>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Software-Technologien-7',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
